module.exports = __webpack_public_path__ + "img/real-time.08a12720.png";